<template>
  <section>
    <div class="titulo">
      <div class="margem container">
        <div class="m-icone direita">
          <SearchBar v-model="machineSearchValue" />
        </div>
        <h2>Cadastro e Associação de Parâmetros de Inspeção</h2>
      </div>
    </div>

    <div class="margem container">
      <div v-if="isLoading" class="loading"></div>
      <div v-if="!isLoading">
        <div class="margem bloco">
          <h3>Parâmetros de Máquina</h3>
          <table class="tabela">
            <tbody>
              <tr>
                <th>Código</th>
                <th>Nome</th>
                <th>Ações</th>
              </tr>
              <tr v-for="ele in displayableMachines" v-bind:key="ele.id" @click="() => onMachineSelected(ele)">
                <td>{{ ele.code }}</td>
                <td>{{ ele.name }}</td>
                <td class="icone-editar"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>

  <ActionModal :show="modal" @close="modal = false">
    <h3 style="text-align: center">Parâmetros para {{ machineSelected.label }}</h3>
    <br />
    <div class="linha">
      <div class="coluna list-param-wrapper">
        <SearchBar v-model="activeParamSearchValue" class="barra-pesquisa-modal" />

        <h3 class="alinha-centro lista-header">Parametros atuais</h3>
        <div v-if="!activeParams || activeParams.length <= 0" style="text-align: center">Nenhum parâmetro associado a esta máquina</div>
        <ul class="param-list">
          <ParamTile class="param-row clicavel" v-for="(ele, index) in filteredActiveParams" v-bind:key="ele.id" :param="ele" @click="() => removeParamFromMachine(ele, index)">
            <template #trailing>
              <span>
                <div style="scale: 1.2" class="icone-avancar"></div>
              </span>
            </template>
          </ParamTile>
        </ul>
      </div>
      <div class="coluna list-param-wrapper">
        <SearchBar v-model="availableParamSearchValue" class="barra-pesquisa-modal" />
        <h3 class="alinha-centro lista-header">Parametros disponíveis</h3>
        <PlusInput @input-finished="registerNewParam" />

        <div v-if="!availableParams || availableParams.length <= 0" style="text-align: center">Nenhum parâmetro associado a esta máquina</div>
        <ul class="param-list">
          <ParamTile @click="() => addParamToMachine(ele)" class="param-row clicavel" v-for="ele in filteredAvailableParams" v-bind:key="ele.id" :param="ele">
            <template #leading>
              <span>
                <div style="scale: 1.2" class="icone-voltar"></div>
              </span>
            </template>
          </ParamTile>
        </ul>
      </div>
    </div>
    <template #actions>
      <div>
        <button class="acao-secundaria" @click="modal = false">Cancelar</button>
      </div>
      <div>
        <button @click="saveParams()">Salvar</button>
      </div>
    </template>
  </ActionModal>
</template>

<script>
import InspectionDataSource from "@/data/datasource/inspection/InspectionDataSource";
import { ActionModal } from "roboflex-thalamus-componentes-vue3-lib";
import PlusInput from "@/components/PlusInput";
import ParamTile from "@/view/inspecao/ParamTile.vue";
import SearchBar from "@/components/SearchBar.vue";

export default {
  name: "ParametrosInspecao",
  components: {
    ActionModal,
    ParamTile,
    SearchBar,
    PlusInput
  },
  data() {
    return {
      isLoading: true,
      modal: false,
      allMachines: null,
      machineSelected: null,
      allParams: null,
      availableParams: null,
      activeParams: null,

      machineSearchValue: "",
      activeParamSearchValue: "",
      availableParamSearchValue: "",
    };
  },
  async created() {
    await Promise.all([InspectionDataSource.getMachinesByCategories().then((e) => (this.allMachines = e)), InspectionDataSource.getParams().then((e) => (this.allParams = e))]);

    this.isLoading = false;
  },
  methods: {
    async onMachineSelected(mach) {
      this.machineSelected = mach;

      this.activeParams = await InspectionDataSource.getParamsForMachine(this.machineSelected);

      this.availableParams = this.allParams.filter((e) => {
        const exists = this.activeParams.some((active) => active.id === e.id);
        return !exists;
      });
      this.modal = true;
    },
    addParamToMachine(param) {
      this.activeParams.push(param);
      const index = this.availableParams.indexOf(param);
      if (index > -1) {
        this.availableParams.splice(index, 1);
      }
    },

    removeParamFromMachine(ele, index) {
      this.activeParams.splice(index, 1);
      this.availableParams.unshift(ele);
    },

    async saveParams() {
      await InspectionDataSource.saveParamsForMachine(this.machineSelected, this.activeParams);
      this.modal = false;
    },

    async registerNewParam(param) {
      let newParam = await InspectionDataSource.createParam(param);
      this.availableParams.push(newParam);
    },
  },
  computed: {
    displayableMachines() {
      if (this.isLoading) return [];

      const search = (this.machineSearchValue || "").toLowerCase();

      return this.allMachines
        .filter((e) => (e.name || "").toLowerCase().includes(search) || (e.code || "").toLowerCase().includes(search));
    },

    filteredAvailableParams() {
      if (this.isLoading) return this.availableParams;
      return this.availableParams.filter((e) => e.description.toLowerCase().includes(this.availableParamSearchValue.toLowerCase()));
    },

    filteredActiveParams() {
      if (this.isLoading) return this.activeParams;
      return this.activeParams.filter((e) => e.description.toLowerCase().includes(this.activeParamSearchValue.toLowerCase()));
    },
  },
};
</script>

<style scoped>
.barra-pesquisa-modal {
  width: 250px;
  margin: auto;
}
.lista-header {
  padding: 12px 0px;
  border-bottom: 1px solid var(--cor-separador);
}

.list-param-wrapper {
  border: 1px solid var(--cor-separador);
  border-radius: 5px;
}

.param-list {
  max-height: 35vh;
  overflow-y: auto;
}

.icone-voltar,
.icone-avancar {
  opacity: 0;
}

.param-row {
  padding: 0px 8px;
}

.param-row:hover .icone-avancar {
  opacity: 1;
  transition: opacity 0.2s ease;
}

.param-row:hover .icone-voltar {
  opacity: 1;
}
</style>
